import React, {useState, useEffect} from 'react'
//! Styles
import './package-detail.style.css'

function PackageDetail({ openDetail, setOpenDetail, packSelected, setPackOrder, packOrder, quantitySelected, setQuantitySelected }) {

    const [order, setOrder] = useState([]);
    const [quantity, setQuantity] = useState(1);

    // reset quantity
    useEffect(() => {
        if(!openDetail)
        {
            setQuantity(1);
        }
    }, [openDetail])
    //console.log(packSelected)
    const increaseQuantity = () => {
        setQuantity(quantity+1)
    }
    const decreaseQuantity = () => {
        if(quantity !== 0)
        {
            setQuantity(quantity-1)
        }else return
    }
    const handleSubmitOrder = () => {
        document.querySelector('body').style.overflow = 'scroll'

        if(quantity === 0)
        {
            setOpenDetail(false)
            return;
        }else
        {
            new Promise(resolve => {
                // declare
                let orderTemp = packOrder;
                let selectTemp = packSelected;
                let duplicated = false;
    
                // new qunatity
                if(orderTemp.length === 0)
                {
                    selectTemp.quantity_selected = quantity;
                    orderTemp.push(selectTemp) 
                    setPackOrder(orderTemp); 
                }else
                {
                    orderTemp.map(order => {
                        if(order.id === selectTemp.id)
                        {
                            order.quantity_selected += quantity;
                            duplicated = true;
                        }
                    })
                    setPackOrder(orderTemp);
    
                    if(!duplicated)
                    {
                        selectTemp.quantity_selected = quantity;
                        orderTemp.push(selectTemp) 
                        setPackOrder(orderTemp);
                    }
                }
                resolve(orderTemp)
            })
            .then(data => {
                let orderQuantity = 0;

                data.map(order => {
                    orderQuantity += order.quantity_selected
                    //console.log(order.quantity_selected);
                })
                setQuantitySelected(orderQuantity);
                // clear
                setQuantity(0);
                setOpenDetail(false);
            })
        }
    }

    const pDetail = (
        <span dangerouslySetInnerHTML={{__html: packSelected.detail}}></span> 
    )

    return (
        <div className={openDetail ? "pkdt-container show" : "pkdt-container close"}>
            <div className="pkdt-wrap">
                {/* header */}
                <div className="pkdt-head_wrap">
                {/* package name */}
                <h1 className="pkdt-packname">{packSelected.pack_type_th} {packSelected.pack_type_en}</h1>
                {/* right */}
                <div className="pkdt-head_right">
                    <i 
                        className="bi bi-chevron-down"
                        onClick={() => {
                            setOpenDetail(false)
                            document.querySelector('body').style.overflow = 'scroll';
                        }}
                    >
                    </i>
                </div>
                </div>

                {/* promotion message */}
                {/* <p className="pkdt-promotion">
                    ซื้อ 2 แพ็กเกจ ขึ้นไป ลดเหลือ ฿ 350 
                </p> */}

                {/* price */}
                <div className="pkdt-price">
                    {/* flash deal price */}
                    <h2>฿ {Number(packSelected.flashdeal_price).toLocaleString('th')}</h2>
                    {/* default price */}
                    <span>฿ {Number(packSelected.price).toLocaleString('th')}</span>
                </div>

                {/* button increase & decrease */}
                <div className="pkdt-button_add">
                    {/* decrease */}
                    <button
                        onClick={decreaseQuantity}
                    >-</button>
                    {/* quantity */}
                    <span>{quantity}</span>
                    {/* increase */}
                    <button
                        onClick={increaseQuantity}
                    >+</button>
                </div>

                {/* button submit */}
                <button 
                    className="pkdt-submit_btn"
                    onClick={handleSubmitOrder}
                >
                    สั่งซื้อ
                </button>
                {/* package description */}
                <ul className="pkdt-desc">
                    <p>รายละเอียด</p>
                    {packSelected.pack_list !== undefined && packSelected.pack_list.map((order, i) => 
                        <li key={i}><span>•</span> <span>{order.pack_name_th}</span></li>
                    )}
                </ul>
                <div className="pkdt-desc-api">
                    {pDetail}
                </div>

                {/* policy order */}
                {/* <ul className="pkdt-policy_order">
                    <span className="policy-title">เงื่อนไขการใช้สั่งซื้อ</span>
                    <li>• สามารถซื้อแพ็กเกจและชำระเงินได้ภายในวันที่ 5-12 ส.ค. 65 เท่านั้น</li>
                    <li>• สามารถรับบริการได้ตั้งแต่วันที่ 8 ส.ค. - 30 ก.ย.65 </li>
                    <li>• สามารถรับบริการได้ที่ Lab Center N Health ทุกสาขา</li>
                </ul> */}

                {/* policy service */}
                {/* <ul className="pkdt-policy_service">
                    <span className="policy-title">เงื่อนไขการใช้บริการ</span>
                    <li><span>1. </span><p>เพื่อให้ท่านได้รับบริการที่สะดวกรวดเร็ว กรุณานัดหมายล่วงหน้า 1 วัน</p></li>
                    <li><span>2. </span><p>กรณีที่ท่านไม่ได้ทำการนัดหมายล่วงหน้าเจ้าหน้าที่ขอตรวจสอบข้อมูล การชำระเงินโดยท่านต้องแสดงหลักฐานใบเสร็จรับเงินกับเจ้าหน้าที่</p></li>
                    <li><span>3. </span><p>หากท่านไม่ได้เป็นผู้เข้ารับการตรวจสุขภาพเอง กรุณาแจ้งข้อมูลเพิ่มเติมกับแอดมินช่องทาง Line : @nhealth</p></li>
                    <li><span>4. </span><p>แพ็กเกจที่ท่านได้สั่งซื้อและชำระเงินแล้ว ไม่สามารถแลก เปลี่ยน หรือคืนเป็นเงินสดได้</p></li>
                    <li><span>5. </span><p>ทางบริษัทขอสงวนสิทธิการเข้ารับบริการหากท่านไม่ปฏิบัติตามเงื่อนไขที่บริษัทกำหนด</p></li>
                </ul> */}

                {/* contact us */}
                <div className="pkdt-contact_us">
                    <h3>สอบถามรายละเอียดและนัดหมายเพื่อรับบริการได้ที่</h3>
                    <span>N Health Customer service 02-7624000 กด1 หรือ กด9</span>
                    <span>Line: @nhealth</span>
                </div>

            </div>      
        </div>
    )
}

export default PackageDetail